import Axios from 'axios'
import { GET_DICTIONARY_ROLE } from './type'

import getDomainURL from 'utils/api'
import { getItem } from 'utils/tokenStore'
import {
  beginAjaxCall,
  ajaxCallError,
  ajaxCallSuccess
} from './ajax'

export const getDictionaryRole = () => dispatch => {
  dispatch( beginAjaxCall() )
  Axios.defaults.headers = {
    common : {
      Authorization: `Bearer ${ getItem( 'BPK_ACCESS_TOKEN' ) }`
    },
    'Access-Control-Allow-Origin': '*'
  }
  Axios.get(
    `${ getDomainURL() }/roles`
  ).then( response => {
    dispatch( getDictionaryRoleSuccess( response.data ) )
    dispatch( ajaxCallSuccess() )
  }).catch( error => {
    dispatch( ajaxCallError( error.response.data.message ) );
  })
}

export const getDictionaryRoleSuccess = payload => ({
  type: GET_DICTIONARY_ROLE,
  payload
})